/**
 * @flow
 * @relayHash f7d3cc01a342c2e4f3febff496a8d58f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Topic_topic$ref = any;
export type TopicAddInput = {
  name: string,
  slug: string,
  seoTitle?: ?string,
  seoDescription?: ?string,
  seoKeywords?: ?string,
  hidden?: ?boolean,
  clientMutationId?: ?string,
};
export type TopicAddMutationVariables = {|
  input: TopicAddInput
|};
export type TopicAddMutationResponse = {|
  +TopicAdd: ?{|
    +topicEdge: ?{|
      +node: ?{|
        +$fragmentRefs: Topic_topic$ref
      |}
    |}
  |}
|};
export type TopicAddMutation = {|
  variables: TopicAddMutationVariables,
  response: TopicAddMutationResponse,
|};
*/


/*
mutation TopicAddMutation(
  $input: TopicAddInput!
) {
  TopicAdd(input: $input) {
    topicEdge {
      node {
        ...Topic_topic
        id
      }
    }
  }
}

fragment Topic_topic on Topic {
  id
  name
  hidden
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "TopicAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "TopicAddInput!"
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "TopicAddMutation",
  "id": null,
  "text": "mutation TopicAddMutation(\n  $input: TopicAddInput!\n) {\n  TopicAdd(input: $input) {\n    topicEdge {\n      node {\n        ...Topic_topic\n        id\n      }\n    }\n  }\n}\n\nfragment Topic_topic on Topic {\n  id\n  name\n  hidden\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TopicAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "TopicAdd",
        "storageKey": null,
        "args": v1,
        "concreteType": "TopicAddPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "topicEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "TopicEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Topic",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "Topic_topic",
                    "args": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TopicAddMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "TopicAdd",
        "storageKey": null,
        "args": v1,
        "concreteType": "TopicAddPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "topicEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "TopicEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Topic",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "id",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hidden",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c09978dbef86277e0c04c33db067b8da';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/TopicAddMutation.graphql.js